import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { MenuContent, OptionsMenu } from '../Common';
import { useAuth } from '../../contexts/AuthContext';
import logoSrc from '../../assets/favicon.svg';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
    position: 'sticky',
    top: 0,
    height: '100vh',
    overflowY: 'auto',
  },
});

interface SideMenuProps {
  currentPage: string;
  onSelectPage: (page: string) => void;
}

export default function SideMenu({ currentPage, onSelectPage }: SideMenuProps) {
  const { user } = useAuth();
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleProfileClick = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
          borderRight: 'none',
        },
      }}
    >
      {/* <Box
        sx={{
          display: 'flex',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 1.5,
        }}
      >
        <SelectContent />
      </Box> */}
      {/* <Divider /> */}

      {/* Logo + app name */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={1.5}
        sx={{ px: 2.5, py: 2.5 }}
      >
        <Box
          component="img"
          src={logoSrc}
          alt="MoneyJar"
          sx={{ width: 32, height: 32, flexShrink: 0 }}
        />
        <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1 }}>
          MoneyJar
        </Typography>
      </Stack>
      {/* <Divider /> */}

      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MenuContent />
        {/* <CardAlert /> */}
      </Box>
      <Stack
        direction="row"
        onClick={handleProfileClick}
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: 'action.hover',
          },
        }}
      >
        <Avatar
          sizes="small"
          alt={user?.name || 'User'}
          src="/static/images/avatar/7.jpg"
          sx={{ width: 36, height: 36 }}
        >
          {user?.name?.charAt(0).toUpperCase()}
        </Avatar>
        <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
            {user?.name || 'User'}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {user?.email || ''}
          </Typography>
        </Box>
      </Stack>
      <OptionsMenu anchorEl={menuAnchorEl} onClose={handleMenuClose} />
    </Drawer>
  );
}
